var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Card } from '@mui/material';
import React from 'react';
import { themeColors } from '../JuvareTheme';
/**
 * Styled container using a Card with a transparent dark theme background.
 *
 * @param {TransparentBoxProps} props - Component props.
 * @param {React.ReactNode} props.children - The content to render inside the TransparentBox.
 * @param {string} props.'data-test' - Custom data-test attribute for the root element.
 * @returns {JSX.Element} The rendered TransparentBox component.
 */
export const TransparentBox = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Card, { variant: 'outlined', sx: {
            backgroundColor: themeColors.alphaDarkSurface.bold,
            borderColor: themeColors.alphaDarkSurface.subtlest,
            color: 'inherit',
            padding: 2,
        }, "data-test": props['data-test'] }, children));
};
